import { __assign } from "tslib";
import { createFakePostResponder, createFakeDeleteResponder } from './../../test-utils';
import { createFakeGetResponder } from '../../test-utils';
// tslint:disable-next-line:max-line-length
import { sendingDomainUri, createEmailDomainApi, emailNotificationUri, sendingDomainsUri } from './index';
import { createHttpTestKit } from '../../http/test-kit';
export var createEmailDomainApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createEmailDomainApi('', fakeHttp);
    var sendingDomainsTestKit = {
        whenGetAllSendingDomains: function () { return createFakeGetResponder(fakeHttp, "/".concat(sendingDomainsUri)); },
        whenGetSendingDomain: function (id) { return createFakeGetResponder(fakeHttp, "/".concat(sendingDomainsUri, "/").concat(id)); },
        whenAddSendingDomain: function (domain) { return createFakePostResponder(fakeHttp, "/".concat(sendingDomainsUri))({ domain: domain }); },
        whenDeleteSendingDomain: function (id) { return createFakeDeleteResponder(fakeHttp, "/".concat(sendingDomainsUri, "/").concat(id)); },
        whenValidateSendingDomain: function (id) { return createFakeGetResponder(fakeHttp, "/".concat(sendingDomainsUri, "/").concat(id, "/isValid")); },
        whenSetDefaultSendingDomain: function (id) { return createFakePostResponder(fakeHttp, "/".concat(sendingDomainsUri, "/").concat(id, "/default"))({}); },
        whenEditSendingDomain: function (dto) {
            if (dto === '*') {
                return createFakePostResponder(fakeHttp, dto)(dto);
            }
            return createFakePostResponder(fakeHttp, "/".concat(sendingDomainsUri, "/").concat(dto.id, "/edit"))(dto);
        },
    };
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetCustomSendingDomain: function () {
            return createFakeGetResponder(fakeHttp, "/".concat(emailNotificationUri, "/").concat(sendingDomainUri));
        },
        whenSetCustomSendingDomain: function (domainName) {
            return createFakePostResponder(fakeHttp, "/".concat(emailNotificationUri, "/").concat(sendingDomainUri, "?domain=").concat(domainName))({});
        },
        whenValidateCustomSendingDomain: function () {
            return createFakePostResponder(fakeHttp, "/".concat(emailNotificationUri, "/").concat(sendingDomainUri, "/validate"))();
        },
        whenDeleteCustomSendingDomain: function () {
            return createFakeDeleteResponder(fakeHttp, "/".concat(emailNotificationUri, "/").concat(sendingDomainUri));
        },
        sendingDomainsTestKit: sendingDomainsTestKit,
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map